module.exports = __webpack_public_path__ + "static/media/lesson-lesson.dbd0ca59.jpg";